

import LeadershipQuote from "../components/our-team/leadership-quote";
import OurTeamDetail from "../components/our-team/our-team";
import Banner from "../components/ui-components/banner";
import { fetchOurTeam } from "../services/api";
import SeoHead from '../components/SeoHead.jsx';
const OurTeam=({lang})=>{

    return(
        <>
         <SeoHead slug="team" lang={lang} />
        <Banner fetchData={fetchOurTeam} lang={lang} />
        <LeadershipQuote lang={lang}/>
<OurTeamDetail lang={lang}/>
        </>
    )
}

export default OurTeam;